module.exports = __webpack_public_path__ + "static/img/24087C_1_2_C_20240604_fit.4efce35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/24087C_1_2_C_20240604_fit.png
// module id = 8Cr2
// module chunks = 0